import { Activity, Church, LockKeyhole } from "lucide-react";
import { triad } from "@/content";
import { Reveal } from "@/components/Reveal";

const icons = [Church, Activity, LockKeyhole];

export default function TriadSection() {
  return (
    <section className="section triad-section" data-testid="restoration-triad-section">
      <div className="section-shell">
        <Reveal className="section-heading-row">
          <div><p className="eyebrow">O MÉTODO EM UMA PÁGINA</p><h2>Três apoios para não depender só da força de vontade.</h2></div>
          <p className="section-side-note">A fé sustenta. O corpo regula. A estrutura financeira protege.</p>
        </Reveal>
        <div className="triad-grid">
          {triad.map((item, index) => {
            const Icon = icons[index];
            return <Reveal key={item.number} delay={index * 90}><article className="triad-item" data-testid={`triad-pillar-${index + 1}`}><span className="triad-number">{item.number}</span><Icon size={24} strokeWidth={1.5} /><h3>{item.name}</h3><p>{item.description}</p><span className="triad-rule">{item.rule}</span></article></Reveal>;
          })}
        </div>
      </div>
    </section>
  );
}
